import { Box, Flex, Heading, Text } from "@chakra-ui/react"
import { useState } from "react"

import Head from 'next/head'
import Image from 'next/image'
import { useRouter } from "next/router"

import popFungi from "../../context/GameContext/popFungi"
import useGerminate from "../../hooks/useGerminate"

const PopFungiCard = ({ title, description, fungiId, imageSrc, sold }) => {
  const router = useRouter()
  // const { germinate } = useGerminate()

  // const onGerminate = async (id:number) => {
  //   const message = await germinate(id)
  //   if (message) alert('You need to connect a wallet.')
  // }

  const onCardClick = () => {
    router.push(`/popfungi/${fungiId}`)
  }

  return (
    <Box m={2} p={4} maxWidth={350} width='100%'  background='black' onClick={onCardClick} cursor='pointer'>
      <Heading m={2} height={20}>{title}</Heading>
      <Text m={2}>{description}</Text>
      <Box py={2}>
        <Image src={imageSrc} width={350} height={350} alt={description} />
      </Box>
      {/* <Flex justify='center' fontFamily='Brilon' p={2}>
        {sold
          ? <Button as='a' href={`${process.env.NEXT_PUBLIC_POPFUNGI_OPENSEA_URL}/${fungiId}`} target='_blank'>View on OpenSea</Button>
          : <Button colorScheme='orange' onClick={() => onGerminate(fungiId)}>Germinate ({process.env.NEXT_PUBLIC_POPFUNGI_COST} eth)</Button>
        }
      </Flex> */}
    </Box>
  )
}

const PopFungiPage = () => {
  // const [filterValue, setFilterValue] = useState<string>()

  // const onFilter = (selected: string) => {
  //   if (selected === filterValue) setFilterValue(null)
  //   else setFilterValue(selected)
  // }

  const filterFungi = (fungi) => {
    // switch (filterValue) {
    //   case 'available':
    //     return !fungi.sold
    //   case 'sold':
    //     return fungi.sold
    //   default:
    //     return true
    // }
    return true
  }

  return (
    <Box pb={16}>
      <Head>
        <title>PopFungi | FreakyFungi</title>
        <meta property="description" content="1/1 Pop Culture and Fungi Inspired NFTs" />

        <meta property="og:title" content="PopFungi" />
        <meta property="og:description" content="1/1 Pop Culture and Fungi Inspired NFTs" />
        <meta property="twitter:title" content="PopFungi" />
        <meta property="twitter:description" content="1/1 Pop Culture and Fungi Inspired NFTs" />

        <meta property="og:image" content="https://freakyfungi.io/images/popfungi/26.png" />
        <meta property="og:url" content="https://freakyfungi.io/popfungi" />

        <meta property="twitter:image" content="https://freakyfungi.io/images/popfungi/26.png" />
        <meta name="twitter:image:alt" content="PopFungi Pikashroom" />
      </Head>

      <Heading as='h1' p={4} textAlign='center' size='2xl'>PopFungi</Heading>

      {/* <Flex p={2} justify='center'>
        <Button m={2} onClick={() => onFilter('available')} isActive={filterValue == 'available'}>Available</Button>
        <Button m={2} onClick={() => onFilter('sold')} isActive={filterValue == 'sold'}>Sold</Button>
      </Flex> */}

      <Flex wrap='wrap' justify='center'>
        {popFungi.filter(filterFungi).map((fungi) => {
          return (
            <PopFungiCard key={fungi.id} fungiId={fungi.id} title={fungi.name} description={fungi.description} imageSrc={fungi.image} sold={fungi.sold} />
          )
        })}
      </Flex>
    </Box>
  )
}

export default PopFungiPage
